import type { PmRule } from "../../lib/pmBoard";

/** The Do / Don't list, read-only. Used on the board home and every job sheet. */
export default function RulesList({ rules }: { rules: PmRule[] }) {
  const dos = rules.filter((r) => r.kind === "do");
  const donts = rules.filter((r) => r.kind === "dont");
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {dos.length > 0 && (
        <ul className="space-y-1.5">
          {dos.map((r) => (
            <li key={r.id} className="flex gap-2 text-sm text-slate-800"><span className="mt-0.5 text-emerald-600">✔</span><span>{r.text}</span></li>
          ))}
        </ul>
      )}
      {donts.length > 0 && (
        <ul className="space-y-1.5">
          {donts.map((r) => (
            <li key={r.id} className="flex gap-2 text-sm text-slate-800"><span className="mt-0.5 text-rose-600">✖</span><span>{r.text}</span></li>
          ))}
        </ul>
      )}
    </div>
  );
}
